import { useMemo } from "react";

export default function useGroupBy(items, { attr, unique = false } = {}) {
  return useMemo(() => {
    if (!attr || !items || items.length === 0) return {};
    return items.reduce((acc, item) => {
      const key = item[attr] ?? null;
      if (unique) {
        acc[key] = item;
        return acc;
      }
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});
  }, [attr, items, unique]);
}
